<template>
  <div class="chooseRecordsBox">
    <div class="topHeader">
      <div
        v-if="isSecondLevel"
        @click="back"
        class="backButton"
      >
        <img
          src="../../assets/img/header/back-button.png"
          alt=""
        />
      </div>
      <p class="newGif"><img
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/login/newgift.png"
          alt=""
        ></p>
      <h5 v-if="!isSecondLevel">备考目标</h5>

    </div>
    <div class="chooseContent">
      <div
        class="oneLevel"
        v-if="!isSecondLevel"
      >
        <p
          v-for="(item, index) in list"
          :key="item.id"
          :class="item.choose ? 'active' : ''"
          @click="chooseOneLevel(index)"
        >
          {{ item.name }}
        </p>
      </div>
      <div
        class="secondLevel"
        v-else
      >
        <div
          class="oneItem"
          v-for="(item, index) in chooseList"
          :key="item.id"
        >
          <p class="fatherTitle"><span></span>{{ item.name }}</p>
          <template v-if="item.selectKY">
            <div
              v-for="(item1,childIndex) in item.data"
              :key="item1.id"
            >
              <p class="subTitle">{{ item1.subname }}</p>
              <div class="twoItem">
                <div
                  v-for="(item2, sonIndex) in item1.data"
                  :key="item2.id"
                >
                  <span
                    :class="[item2.choose ? 'active' : '',item2.choose&&childIndex===2?'subIntroActive':'']"
                    @click="chooseTwoLevelKY(index,childIndex, sonIndex, item2)"
                  >
                    {{ item2.title }}

                  </span>
                  <div
                    class="subIntro"
                    v-if="item2.subtitle&&item2.choose"
                  >
                    <div> {{item2.subtitle}}</div>
                  </div>

                </div>

              </div>

            </div>

          </template>
          <template v-else>
            <div class="twoItem">
              <div
                v-for="(item1, childIndex) in item.childLabelTreeVOList"
                :key="item1.id"
              >
                <span
                  :class="item1.choose ? 'active' : ''"
                  @click="chooseTwoLevel(item1.contentType, index, childIndex, item)"
                >
                  {{ item1.name }}

                </span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="buttons">
      <img
        v-if="isSecondLevel"
        class="newTip"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/login/newTip.png"
        alt=""
      >
      <button
        :disabled="!chooseList.length"
        v-if="!isSecondLevel"
        @click="isSecondLevel = true"
      >
        下一步
      </button>
      <button
        :disabled="hasKy?!chooseSecond||chooseKy!==4:!chooseSecond"
        v-else
        @click="submit"
      >选好了</button>
    </div>
  </div>
</template>
<script>
import { chooseRecordsList, saveChooseRecords } from '@/api/chooseRecords';
import { reqReceiveGift } from '@/api/newUser';

export default {
  data() {
    return {
      isSecondLevel: false, // true 二级 false 一级
      list: [], // 所有的列表
      chooseList: [], // 选中的一级列表
      chooseKy: 0, // 考研内选择几个
      hasKy: false, // 是否选择考研
    };
  },
  computed: {
    chooseSecond() {
      // true 已经选择完成 false 未选择完
      let index = 0;
      this.chooseList.forEach((item) => {
        if (item.childLabelTreeVOList.some((item1) => item1.choose)) {
          index += 1;
        }
      });
      console.log(index === this.chooseList.length, 'index === this.chooseList.length');

      return index === this.chooseList.length;
    },
  },
  methods: {
    back() {
      this.isSecondLevel = false;
    },
    getChooseRecordsList() {
      // 获取列表
      chooseRecordsList()
        .then((result) => {
          this.list = result.data;
          this.chooseList = this.list.filter((item) => item.choose); // 已选中的数据
          this.chooseList.map((item) => {
            if (item.name === '考研') {
            this.hasKy = true;
            // eslint-disable-next-line no-unused-expressions
            item.childLabelTreeVOList?.map((val) => {
            Object.assign(val, {
              title: val.name,
            });
          });
          Object.assign(item, {
            selectKY: true,
            data: [
              {
                subname: '学习阶段',
                data: item.learnStage,

              },
              {
                subname: '考研时间',
                data: item.childLabelTreeVOList,

              },
              {
                subname: '备考阶段',
                data: item.readyExam,

              },
              {
                subname: '是否二战',
                data: item.beAgainList,

              },
            ],

          });
        }
      });
        })
        .catch((err) => {

        });
    },
    // 选择一级列表
    chooseOneLevel(index) {
      this.list[index].choose = !this.list[index].choose;
      this.chooseList = this.list.filter((item) => item.choose); // 已选中的数据
      this.chooseList.map((item) => {
        if (item.name === '考研') {
          this.hasKy = true;
          // eslint-disable-next-line no-unused-expressions
          item.childLabelTreeVOList?.map((val) => {
            Object.assign(val, {
              title: val.name,
            });
          });
          Object.assign(item, {
            selectKY: true,
            data: [
              {
                subname: '学习阶段',
                data: item.learnStage,

              },
              {
                subname: '考研时间',
                data: item.childLabelTreeVOList,

              },
              {
                subname: '备考阶段',
                data: item.readyExam,

              },
              {
                subname: '是否二战',
                data: item.beAgainList,

              },
            ],

          });
        }
      });
    },
    // 选择二级
    chooseTwoLevel(contentType, index, childIndex, item) {
      // contentType 0 单选 1 多选  index 父级索引 childIndex 子级索引
      if (item.contentType === 0) {
        // eslint-disable-next-line
        this.chooseList[index].childLabelTreeVOList.forEach((item) => (item.choose = false));
      }
      this.chooseList[index].childLabelTreeVOList[childIndex].choose = !this.chooseList[index].childLabelTreeVOList[childIndex].choose;
    },
    // 选择二级（考研）
    chooseTwoLevelKY(index, childIndex, sonIndex, item) {
      // eslint-disable-next-line
      this.chooseList[index].data[childIndex].data.forEach((item) => (item.choose = false));
      this.chooseList[index].data[childIndex].data[sonIndex].choose = !this.chooseList[index].data[childIndex].data[sonIndex].choose;
      this.$forceUpdate();
      this.checkKy();
    },
    checkKy() {
      let index = 0;
      this.chooseList.forEach((item) => {
        if (item.name === '考研') {
          item.data.map((val) => {
            if (val.data.some((item1) => item1.choose)) {
              index += 1;
            }
          });
        }
      });
      this.chooseKy = index;
    },
    submit() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      // 提交数据
      let labelTreeIdList = [];
      let learnStage = '';
      let readyExam = '';
      let beAgain = "";
      this.chooseList.forEach((item) => {
        if (item.name === '考研') {
          learnStage = item.data[0].data.filter((childItem) => childItem.choose)[0]?.value;
          readyExam = item.data[2].data.filter((childItem) => childItem.choose)[0]?.value;
          beAgain = item.data[3].data.filter((childItem) => childItem.choose)[0]?.value;
        }
        const arr = item.childLabelTreeVOList.filter((childItem) => childItem.choose);
        arr.forEach((childItem) => {
          labelTreeIdList = [...labelTreeIdList, childItem.parentId, childItem.id];
        });
      });

      const LabelChooseInsertReqVO = {
        company: 0,
        labelTreeIdList,
        learnStage: Number(learnStage),
        readyExam,
        beAgain,
      };
      saveChooseRecords(LabelChooseInsertReqVO)
        .then((result) => {
          if (result.code === 0) {
            this.$toast({
              message: '提交成功',
              position: 'middle',
              duration: 1500,
            });
            this.getUserGift();
            this.$emit('closeChooesRecords');
          } else {
            this.$toast({
              message: '提交失败，请重试',
              position: 'middle',
              duration: 2000,
            });
          }
        })
        .catch((err) => {
        });
    },
    async getUserGift() {
      const data = {
        ip: sessionStorage.getItem('cityIp') || '',
        terminalMark: this.$global.terminalMark,
      };
      await reqReceiveGift(data);
    },
  },
  mounted() {
    this.getChooseRecordsList();
  },
};
</script>
<style lang="scss" scoped>
.chooseRecordsBox {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2000;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: #fff;
  .topHeader {
    //   position: fixed;
    width: 100%;
    padding: 53px 36px 43px 36px;
    .backButton {
      width: 33px;
      height: 33px;
      margin-bottom: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    p.newGif {
      img {
        width: 678px;
        height: 178px;
        margin-top: 10px;
      }
    }
    h5 {
      margin-top: 58px;
      color: #333;
      font-weight: 500;
      font-size: 36px;
      line-height: 51px;
    }
  }
  .chooseContent {
    height: 67%;
    padding-bottom: 65px;
    overflow: hidden;
    overflow-y: scroll;
    .oneLevel {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      // justify-content: space-between;
      padding: 0 36px;
      p {
        width: 326px;
        height: 83px;
        margin-bottom: 45px;
        padding: 0 25px;
        color: #333;
        font-size: 25px;
        line-height: 83px;
        text-align: center;
        background: #fff;
        border: 2px solid #d5d5d5;
        border-radius: 45px;
      }
      p:nth-child(2n + 2) {
        margin-right: 0;
      }
      .active {
        color: #fff;
        background: #ff6c02;
        border: none;
      }
    }
    .secondLevel {
      padding: 0 36px;
      .oneItem {
        .fatherTitle {
          display: flex;
          margin-bottom: 22px;
          color: #333;
          font-weight: 500;
          font-size: 36px;
          span {
            display: block;
            width: 5px;
            height: 29px;
            margin-right: 7px;
            background: #ff7f41;
            border-radius: 5px;
          }
        }
        .subTitle {
          color: #333;
          font-weight: 400;
          font-size: 29px;
          line-height: 40px;
        }
        .twoItem {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          padding-bottom: 58px;
          > div {
            position: relative;
            margin-right: 20px;
            span {
              display: block;
              width: 210px;
              height: 69px;
              margin-top: 25px;
              color: #333;
              font-size: 25px;
              line-height: 69px;
              text-align: center;
              border: 2px solid #d5d5d5;
              border-radius: 34px;
            }
            .subIntro {
              position: absolute;
              top: 95px;
              left: 0;
              > div {
                position: relative;
                width: 400px !important;
                height: 51px;
                margin-top: 10px;
                padding: 0 8px;
                color: #ff7f41;
                font-weight: 400;
                font-size: 22px;
                line-height: 51px;
                text-align: center;
                background: #fef5f1;
                border-radius: 11px;
                &::before {
                  position: absolute;
                  top: -9px;
                  left: 50px;
                  width: 20px;
                  height: 9px;
                  background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/login/sj.png');
                  background-size: 100% 100%;
                  content: '';
                }
              }
            }
            .subIntroActive {
              margin-bottom: 55px;
            }
          }
          > div:nth-child(3),
          > div:nth-child(6) {
            .subIntro {
              position: absolute;
              top: 95px;
              left: -200px;
              > div::before {
                top: -9px;
                left: 300px;
              }
            }
          }
          > div:nth-child(3n) {
            margin-right: 0;
          }

          .active {
            color: #fff;
            background: #ff6c02;
            border: none;
          }
        }
      }
    }
  }
  //   .chooseContent::-webkit-scrollbar {
  //       display: none;
  //   }

  .buttons {
    position: fixed;
    bottom: 87px;
    left: 50%;
    width: 636px;
    height: 82px;
    border-radius: 45px;
    transform: translateX(-50%);
    .newTip {
      position: absolute;
      right: 0;
      bottom: 82px;
      width: 303px;
      height: 60px;
    }
    button {
      width: 100%;
      height: 100%;
      color: #fff;
      font-size: 29px;
      background: #ff6c02;
      border-radius: 45px;
    }
    button[disabled] {
      background: #ffb580;
    }
  }
}
</style>
